import Flickity from 'flickity';
import 'flickity-imagesloaded';

window.carousel = () => {
	return {
	  	init() {
			var flkty = new Flickity(this.$refs.carousel, {
				wrapAround: true,
				pageDots: false,
				prevNextButtons: false,
				imagesLoaded: true
			});
		}
	}
}

let map, markers;

window.initMap = async function(){

	const mapEl = document.getElementById("map");

	const mapSettings = JSON.parse( mapEl.dataset.settings );
	console.log(mapSettings);

	map = new google.maps.Map(mapEl, {
		mapId: "53004cff74f3fba5",
		center: {
		  lat: mapSettings.lat,
		  lng: mapSettings.lng
		},
		zoom: mapSettings.zoom,
		streetViewControl: false,
		mapTypeControl: false,
		fullscreenControl: false
	});

	const infoWindow = new google.maps.InfoWindow();
	// const bounds = new google.maps.LatLngBounds();

	markers = await fetchMarkers();
	markers.forEach( item => {

		// add to bounds
		// const pos = new google.maps.LatLng (item.stockist_location.lat, item.stockist_location.lng)
    	// bounds.extend(pos);

		// add marker
		const marker = new google.maps.Marker({
			map,
			position: {
				lat: item.stockist_location.lat,
				lng: item.stockist_location.lng
			},
			icon: {
				path: google.maps.SymbolPath.CIRCLE,
				fillColor: "#df262a",
				fillOpacity: 0.66,
				strokeWeight: 0,
				scale: 5,
			},
			animation: null,
			title: item.stockist_name,
			optimized: true
		});

		marker.addListener("click", () => {
			infoWindow.close();
			infoWindow.setContent(marker.getTitle());
			infoWindow.open(marker.getMap(), marker);

			map.panTo(marker.getPosition());
			map.setZoom(15);
		});


	});

	// map.fitBounds(bounds);

};


const fetchMarkers = async function() {
	let url = './wp-json/wp/v2/pages/177';
	try {
		let response = await fetch(url);
        let data = await response.json();
		return data.acf.stockist_items;
	}catch( error ){
		console.log(error);
	}
}